module.exports = __webpack_public_path__ + "img/project-edu-06.da91eb66.png";